const islands = {
  antigua: {
    name: "Antigua & Barbuda",
    hero: "/Images/islands/antigua-hero.jpg",
    title: "Creative Title Insert Here",
    subtitle: "Discover bespoke itineraries across the globe’s most exclusive yachting havens.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus. Vivamus commodo, sem at tincidunt mattis, arcu velit.",
    section1: {
      image: "/Images/islands/antigua-sec1.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus. Vivamus commodo, sem at tincidunt mattis, arcu velit.",
    },
    section2: {
      image: "/Images/islands/antigua-sec2.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus. Vivamus commodo, sem at tincidunt mattis, arcu velit.",
    },
  },

 grenada: {
    name: "Grenada",
    hero: "/Images/islands/grenada-hero.jpg",
    title: "Creative Title Insert Here",
    subtitle: "Discover bespoke itineraries across the globe’s most exclusive yachting havens.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    section1: {
      image: "/Images/islands/grenada-sec1.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
    section2: {
      image: "/Images/islands/grenada-sec2.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
  },

  stlucia: {
    name: "St. Lucia",
    hero: "/Images/islands/stlucia-hero.jpg",
    title: "Creative Title Insert Here",
    subtitle: "Discover bespoke itineraries across the globe’s most exclusive yachting havens.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    section1: {
      image: "/Images/islands/stlucia-sec1.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
    section2: {
      image: "/Images/islands/stlucia-sec2.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
  },
  stThomas: {
    name: "St. Thomas (USVI)",
    hero: "/Images/islands/stThomas-hero.jpg",
    title: "Creative Title Insert Here",
    subtitle: "Discover bespoke itineraries across the globe’s most exclusive yachting havens.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    section1: {
      image: "/Images/islands/stThomas-sec1.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
    section2: {
      image: "/Images/islands/stThomas-sec2.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
  },
   trinidad: {
    name: "Trinindad and Tobago",
    hero: "/Images/islands/trinidad-hero.jpg",
    title: "Creative Title Insert Here",
    subtitle: "Discover bespoke itineraries across the globe’s most exclusive yachting havens.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    section1: {
      image: "/Images/islands/trinidad-sec1.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
    section2: {
      image: "/Images/islands/trinidad-sec2.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
  },
  stMarteen: {
    name: "St. Maarten",
    hero: "/Images/islands/stMarteen-hero.jpg",
    title: "Creative Title Insert Here",
    subtitle: "Discover bespoke itineraries across the globe’s most exclusive yachting havens.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    section1: {
      image: "/Images/islands/stMarteen-sec1.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
    section2: {
      image: "/Images/islands/stMarteen-sec2.jpg",
      title: "Insert Title",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus posuere elit et nulla dapibus, in tincidunt lectus cursus.",
    },
  },
  
};

export const islandOrder = ["antigua", "grenada", "stlucia", "stThomas","trinidad","stMarteen"];
export default islands;
